import { motion } from "framer-motion";
import { CONTENT } from "@/content";

const lineVariant = {
  hidden: { y: "110%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.3 + i * 0.18 },
  }),
};

export default function Hero() {
  return (
    <section
      className="relative min-h-screen flex flex-col justify-center px-6 md:px-16 overflow-hidden"
      data-testid="hero-section"
    >
      {/* ambient glow */}
      <div
        className="absolute -top-40 -right-20 w-[40rem] h-[40rem] rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(232,180,184,0.14), transparent 65%)",
        }}
      />
      <div
        className="absolute bottom-0 left-0 w-[30rem] h-[30rem] rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(212,175,55,0.08), transparent 65%)",
        }}
      />

      <motion.p
        className="font-script text-3xl md:text-5xl mb-4"
        style={{ color: "var(--rose)" }}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 1 }}
        data-testid="hero-script"
      >
        {CONTENT.hero.script}
      </motion.p>

      <h1 className="font-serif-d tracking-tightest font-light leading-[0.9]">
        {CONTENT.hero.lines.map((line, i) => (
          <span key={i} className="block overflow-hidden">
            <motion.span
              className={`block text-[19vw] md:text-[13vw] lg:text-[11rem] ${
                i === 2 ? "shimmer-gold" : ""
              }`}
              style={i === 2 ? { fontStyle: "italic" } : {}}
              variants={lineVariant}
              initial="hidden"
              animate="show"
              custom={i}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </h1>

      <motion.p
        className="font-body max-w-xl mt-10 text-base md:text-lg leading-relaxed"
        style={{ color: "var(--muted-rose)" }}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.2, duration: 1 }}
        data-testid="hero-sub"
      >
        {CONTENT.hero.sub}
      </motion.p>

      <motion.div
        className="absolute bottom-10 right-6 md:right-16 flex items-center gap-3 text-xs uppercase tracking-[0.3em]"
        style={{ color: "var(--muted-rose)" }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.7 }}
        transition={{ delay: 1.8, duration: 1 }}
      >
        <span className="w-16 h-px" style={{ background: "var(--muted-rose)" }} />
        <motion.span
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 1.8, repeat: Infinity }}
        >
          scroll
        </motion.span>
      </motion.div>
    </section>
  );
}
